app.selftests = {
    settings: {
        $el: $('.selftest'),
        $progress: $('.progress-bar .progress')
    },

    currentStep: 1,
    scoring: [],

    init: function () {
        var self = this;

        if (app.selftests.settings.$el.length > 0) {
            app.selftests.updateStep(1);
        }

        app.selftests.settings.$el.find(".btn.previous").on("click", app.selftests.previousStep);
        app.selftests.settings.$el.find(".btn.next").on("click", app.selftests.nextStep);
        app.selftests.settings.$el.find("input[type=radio]").on("click", app.selftests.updateDisabledState);
    },

    updateStep: function(whichStep) {
        app.selftests.currentStep = whichStep;
        app.selftests.settings.$el.find(".step").hide();
        app.selftests.settings.$el.find(".step[data-step=" + whichStep + "][data-resultcondition='']").show();

        app.selftests.settings.$el.find(".stepbuttons").hide();

        var maxStep = app.selftests.settings.$el.data("maxstep");

        app.selftests.settings.$progress.css('width', Math.round((whichStep / maxStep) * 100) + '%');

        if (maxStep !== whichStep) {
            if (whichStep === 1) {
                app.selftests.settings.$el.find(".stepbuttons[data-step=1]").show();
            } else {
                app.selftests.settings.$el.find(".stepbuttons[data-step='*']").show();
            }
        } else {
            app.selftests.saveSubmission();
        }

        app.selftests.showConditionalTexts();
        app.selftests.updateDisabledState();
    },

    previousStep: function(ev) {
        if (ev && ev.preventDefault) {
            ev.preventDefault();
        }

        app.selftests.updateStep(--app.selftests.currentStep);
    },

    nextStep: function(ev) {
        if (ev && ev.preventDefault) {
            ev.preventDefault();
        }

        app.selftests.calculateScore();

        app.selftests.updateStep(++app.selftests.currentStep);
    },

    calculateScore: function() {
        var scoringgroups = app.selftests.settings.$el.find(".step[data-step=" + app.selftests.currentStep + "][data-scoringgroup!='']");

        // Clear existing scoregroup value
        scoringgroups.each(function(ind,elm) {
            var key = $(this).data('scoringgroup');
            app.selftests.scoring[ key ] = 0;
        });

        scoringgroups.each(function(ind,elm) {
            var key = $(this).data('scoringgroup');

            if (typeof app.selftests.scoring[ key ] === "undefined" || app.selftests.scoring[ key ] === undefined) {
                app.selftests.scoring[ key ] = 0;
            }

            var value = $(this).find("input[type=radio]:checked").val();
            if (value !== undefined && typeof value !== "undefined") {
                app.selftests.scoring[ key ] += parseInt(value);
            }
        });
    },

    showConditionalTexts: function() {
        var conditionals = app.selftests.settings.$el.find(".step[data-step=" + app.selftests.currentStep + "][data-resultcondition!='']");

        // Conditional texts are present
        if (conditionals.length > 0) {
            conditionals.each(function(ind,elm){
                var expression = $(this).data("resultcondition");
                for ( var kName in app.selftests.scoring ) {
                    var re = new RegExp(kName, "g");
                    expression = expression.replace(re, app.selftests.scoring[kName]);
                }

                /* jshint ignore:start */
                var result = eval(expression);
                /* jshint ignore:end */
                if (result===true) {
                    $(this).show();
                }
            });
        }
    },

    updateDisabledState: function(ev) {
        var scoringgroups = app.selftests.settings.$el.find(".step[data-step=" + app.selftests.currentStep + "][data-scoringgroup!='']");
        if (scoringgroups.length > 0) {
            var mayContinue = true;

            scoringgroups.each(function(ind,elm){
                var value = $(this).find("input[type=radio]:checked").val();
                if (value === undefined || typeof value === "undefined") {
                    mayContinue = false;
                }
            });

            if (mayContinue) {
                app.selftests.settings.$el.find(".btn.next").removeClass("btn--disabled");
            } else {
                app.selftests.settings.$el.find(".btn.next").addClass("btn--disabled");
            }
        } else {
            app.selftests.settings.$el.find(".btn.next").removeClass("btn--disabled");
        }
    },

    saveSubmission: function() {
        var formType = app.selftests.settings.$el.data("selftest");
        var choices = [];
        var scoringgroups = app.selftests.settings.$el.find(".step[data-scoringgroup!='']");

        scoringgroups.each(function(ind,elm) {
            var sel = $(this).find("input[type=radio]:checked");
            var value = sel.val();
            var id = sel.attr("id");
            var label = $(this).find("label[for='" + id + "']");

            if (value !== undefined && typeof value !== "undefined") {
                var obj = {};

                obj.step = $(this).data("step");
                obj.sId = $(this).data("sid");
                obj.title = $(this).find("span.content").html();
                obj.choiceTitle = label.html();
                obj.choiceValue = value;

                choices.push(obj);
            }
        });

        var saveObj = {
            "type": formType,
            "choices": choices
        };

        context.call({
            url: '/',
            method: 'storeZelftest',
            type: 'post',
            params: saveObj
        });

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({
            'event' : 'zelftest-' + formType,
            'eventCategory' : 'Zelftest',
            'eventAction' : formType ,
            'eventLabel' : 'Afgerond'
        });
    }
};